import React from 'react';
import { Button } from 'semantic-ui-react';
import '../primitives.css';

/** A wrapper that styles the semantic button to appear as a hyper link. Note that we add two styles to increase css specificity */
const ButtonLink = _ref => {
  let {
    className,
    color,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button
  // <div
  , Object.assign({
    basic: true,
    compact: true,
    as: "div",
    color: color === 'white' ? null : color || 'blue',
    className: "link1 link2".concat(color === 'white' ? ' white' : '', " ").concat(className)
  }, props));
};
ButtonLink.defaultProps = {
  props: undefined,
  className: ''
};
export default ButtonLink;